import {NavLink as ReactRouteNavLink} from 'react-router-dom';
import {useApplications} from "../../../applications";
import {
    DashboardWidgetBuilder,
    WidgetDataPoint,
    WidgetType
} from "@flexinet/ui-components";

export const ApplicationsWidget = () => {

    const {
        items,
    } = useApplications()

    const dataPoints: WidgetDataPoint[] = [];
    dataPoints.push({
                        value: items.length,
                        label: 'Applications',
                        color: 'flexinet',
                    });


    const widget: WidgetType = {
        header: {
            title: 'Applications',
        },
        body: {
            dataPoints: dataPoints,
            metrics: [],
        },
        footer: {
            actionItems: [
                {
                    label: 'View All',
                    description:
                        'View All Applications',
                    component: {ReactRouteNavLink},
                    to: '/applications',
                    visible: true
                },
                {
                    label: 'Onboard Application',
                    description:
                        'Onboard new application',
                    component: {ReactRouteNavLink},
                    to: '/applications/add',
                    visible: true,
                },
            ],
        }
    };

    return <DashboardWidgetBuilder widget={widget}/>;
};
